import styles from "./styles.module.css";
import { MdClose } from "react-icons/md";
import { db } from "../../firebase";
import { useEffect, useState } from "react";

export default function ({ open, onClose, onAdd, plugins: addedPlugins }) {
  const [plugins, setPlugins] = useState([]);
  console.log(addedPlugins);
  useEffect(() => {
    const unsub = db
      .collection("plugins")
      .where("public", "==", true)
      .onSnapshot((snap) => {
        setPlugins(snap.docs.map((x) => ({ ...x.data(), id: x.id })));
      });
    return unsub;
  }, []);

  return (
    <div
      onClick={onClose}
      className={
        open ? styles.background + " " + styles.open : styles.background
      }
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={open ? styles.search + " " + styles.open : styles.search}
      >
        <div className={styles.searchTop}>
          <div className={styles.searchTitle}>Add Plugin</div>
          <MdClose onClick={onClose} className={styles.closeIcon} />
        </div>
        <div className={styles.searchBar}>
          <div className={styles.inputTitle}>Search</div>
          <input className="input" />
        </div>
        {plugins.map((x) => {
          return (
            <SearchItem
              key={x.name}
              plugin={x}
              added={addedPlugins.includes(x.name)}
              onAdd={onAdd}
              onRemove={() => {}}
            />
          );
        })}
      </div>
    </div>
  );
}

const SearchItem = ({ plugin, added, onAdd, onRemove }) => {
  return (
    <div className={styles.searchItem}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          style={{ backgroundImage: `url(${plugin.pluginIcon})` }}
          className={styles.pluginImage}
        />
        <div className={styles.itemContent}>
          <div className={styles.title}>{plugin.displayName}</div>
          <div className={styles.description}>{plugin.description}</div>
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <button className={styles.info}>MORE INFO</button>
        {!added && (
          <button onClick={() => onAdd(plugin)} className={styles.add}>
            ADD PLUGIN
          </button>
        )}
      </div>
    </div>
  );
};
